import { CalendarClock, ClipboardList, FileStack, FileText, Home, Sparkles } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { MIN_TIER_FOR_BOOKINGS } from '../lib/packageGating';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  /** Package tier (P21-T06) required to use this feature — omitted means
   * every tier can. Set, the nav item still renders (with a locked state)
   * so the client can discover and upgrade into it, rather than being
   * hidden outright. */
  requiredTier?: number;
}

/** Shared primary-nav item constants — used by both `AppShell`'s desktop
 * sidebar and `BottomNav`'s mobile tab bar so the two never drift apart.
 * Kept in their own module rather than exported from `AppShell.tsx`: that
 * would make `BottomNav.tsx` and `AppShell.tsx` import each other, and since
 * these are module-scope consts (evaluated at import time, not inside a
 * component), the circular import resolves with one side still
 * `undefined`. */
export const HOME: NavItem = { to: '/app', label: 'Home', icon: Home, end: true };
export const REPORT: NavItem = { to: '/app/report', label: 'Report', icon: FileText };
export const QUESTIONNAIRES: NavItem = {
  to: '/app/questionnaires',
  label: 'Questionnaires',
  icon: ClipboardList,
};
export const BOOKINGS: NavItem = {
  to: '/app/bookings',
  label: 'Bookings',
  icon: CalendarClock,
  requiredTier: MIN_TIER_FOR_BOOKINGS,
};
/** Sidebar-only (not in `BottomNav`'s fixed 4-item mobile tab bar) — see
 * `AppShell.tsx`'s `SIDEBAR_GROUPS`. */
export const RESOURCES: NavItem = {
  to: '/app/resources',
  label: 'Resources',
  icon: FileStack,
};
/** Sidebar-only (and in the mobile account menu) — release notes aimed at
 * clients, see `pages/WhatsNewPage.tsx`. */
export const WHATS_NEW: NavItem = {
  to: '/app/whats-new',
  label: 'What’s new',
  icon: Sparkles,
};
